import { Theme, useMediaQuery } from '@mui/material';
import { AppHeaderMain, AppHeaderMobile } from 'components/app-header/components';
import React from 'react';

export const AppHeader: React.FC = () => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  return <>{isMobile ? <AppHeaderMobile /> : <AppHeaderMain />}</>;
};
